import { jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';

const SkeletonBox = ({ loading = true, className, children, dark = false, locale = {
    ariaText: 'Please wait',
    ariaLabel: 'Loading'
} })=>{
    if (loading) {
        return jsx("span", {
            "aria-label": locale.ariaLabel,
            "aria-valuemax": 100,
            "aria-valuemin": 0,
            "aria-valuetext": locale.ariaText,
            className: classNames('cb-skeleton-box', {
                dark
            }, className),
            "data-testid": "skeleton-box",
            role: "progressbar",
            tabIndex: -1,
            "aria-busy": true
        });
    }
    return jsx(Fragment, {
        children: children
    });
};
SkeletonBox.displayName = 'SkeletonBox';

export { SkeletonBox, SkeletonBox as default };
//# sourceMappingURL=SkeletonBox.es.js.map
